import { render, staticRenderFns } from "./WallPost.vue?vue&type=template&id=56b1cdd0&scoped=true&"
import script from "./WallPost.vue?vue&type=script&lang=js&"
export * from "./WallPost.vue?vue&type=script&lang=js&"
import style0 from "./WallPost.vue?vue&type=style&index=0&id=56b1cdd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1cdd0",
  null
  
)

export default component.exports